import { KpopStudyPageTemplate } from "@/components/KpopStudyPageTemplate";

const StudyWithTwice = () => {
  return (
    <KpopStudyPageTemplate
      groupName="TWICE"
      groupNameDisplay="TWICE"
      fandomName="ONCE"
      seoTitle="Study With TWICE - ONCE Study Rooms"
      seoDescription="Study with TWICE fans worldwide. Join ONCEs in virtual study rooms with TWICE playlists and themed spaces."
      seoKeywords="study with twice, twice study room, once study, kpop study room"
      canonicalUrl="/study-with-twice/"
      heroDescription="Join ONCE worldwide who study with TWICE's bright and positive energy. Stay motivated and focused."
      aboutContent={
        <>
          <p>
            <a href="https://twice.jype.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TWICE</a> is one of the most popular K-Pop girl groups, formed by <a href="https://www.jype.com/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">JYP Entertainment</a>. The nine-member group has captured hearts worldwide.
          </p>
          <p>
            ONCE find joy in TWICE's positive energy. Follow them on <a href="https://www.instagram.com/twicetagram/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Instagram</a>, <a href="https://twitter.com/JYPETWICE" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">X (Twitter)</a>, and <a href="https://www.youtube.com/@TWICE" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">YouTube</a>.
          </p>
        </>
      }
      riseOfContent={
        <p>
          TWICE fans have created spaces to combine their passion with productive study sessions, playing <a href="https://open.spotify.com/artist/7n2Ycct7Beij7Dj7meI4X0" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">TWICE's music on Spotify</a> in the background.
        </p>
      }
      featureCards={[
        { title: "TWICE Study Playlists", desc: "Stay positive with curated TWICE playlists." },
        { title: "Global ONCE Community", desc: "Connect with ONCE from around the world." },
        { title: "Colorful Themed Rooms", desc: "Study in TWICE-themed rooms with bright aesthetics." },
        { title: "One In A Million Sessions", desc: "Join TWICE study sessions anytime." },
      ]}
      whyPerfectDescription="CSW is more than just a study platform; it's a place where fans of TWICE can come together, stay motivated, and achieve their goals."
      communityDescription1="CSW – Chill Study Work is more than just a study platform; it's a place to connect with like-minded individuals."
      communityDescription2="Discover how studying with your favorite idols can transform your academic journey."
      socialLinks={[
        { name: "Official Website", url: "https://twice.jype.com/" },
        { name: "YouTube", url: "https://www.youtube.com/@TWICE" },
        { name: "Instagram", url: "https://www.instagram.com/twicetagram/" },
        { name: "X (Twitter)", url: "https://twitter.com/JYPETWICE" },
        { name: "Spotify", url: "https://open.spotify.com/artist/7n2Ycct7Beij7Dj7meI4X0" },
      ]}
      youtubeVideos={[
        { id: "kOHB85vDuow", title: "TWICE - SET ME FREE M/V" },
        { id: "pok5yDw77uM", title: "TWICE - MOONLIGHT SUNRISE M/V" },
        { id: "CM4CkVFmTds", title: "TWICE - The Feels M/V" },
        { id: "mH0_XpSHkZo", title: "TWICE - I CANT STOP ME M/V" },
        { id: "kOHB85vDuow", title: "TWICE - Talk that Talk M/V" },
        { id: "V2hlQkVJZhE", title: "TWICE - Alcohol-Free M/V" },
      ]}
      youtubeChannelUrl="https://www.youtube.com/@TWICE"
      youtubeChannelName="TWICE"
    />
  );
};

export default StudyWithTwice;
